export interface SelectedMention { start: number; length: number; userId: string }

export function remapMentions(selections: SelectedMention[], before: string, after: string): SelectedMention[] {
  let start = 0;
  while (start < before.length && start < after.length && before[start] === after[start]) start++;
  let end = before.length, nextEnd = after.length;
  while (end > start && nextEnd > start && before[end - 1] === after[nextEnd - 1]) { end--; nextEnd--; }
  const shift = nextEnd - end;
  return selections.flatMap(item => {
    if (item.start + item.length <= start) return [item];
    if (item.start >= end) return [{ ...item, start: item.start + shift }];
    return [];
  });
}

export function mentionQuery(value: string, cursor: number): { start: number; query: string } | null {
  const before = value.slice(0, cursor);
  const line = before.slice(before.lastIndexOf("\n") + 1);
  if (line.trimStart().startsWith(">") || (before.match(/```/g)?.length ?? 0) % 2 || (line.match(/(?<!`)`(?!`)/g)?.length ?? 0) % 2) return null;
  const match = /(?:^|[\s([.,;:!?])@([a-zA-Z0-9_-]*)$/.exec(before);
  return match ? { start: cursor - match[1].length - 1, query: match[1] } : null;
}
